gsap.registerPlugin(ScrollTrigger);
const bodys = gsap.utils.toArray('body');

let mm = gsap.matchMedia();

bodys.forEach((body) => {
 gsap.from(body, {
    scrollTrigger: {
      trigger: '.text-info-with-image',
      start:"top 40%",
      end:"top 80%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.remove('dark-bg');
      }
    }
  });
  
mm.add("(min-width: 992px)", () => {
  //Scrolling Cards
  let horizontalSection = document.querySelector('.banner-slider-ele');
  
  gsap.to('.banner-slider-ele', {
    x: () => horizontalSection.scrollWidth * -1,
    xPercent: 100,
    scrollTrigger: {
      trigger: '.banner-slider-ele',
      start: 'center center',
      end: '+=2000px top',
      pin: '.banner-slider-main',
      scrub: true,
      invalidateOnRefresh: true,
    }
  });
});
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.text-with-image-main',
      start:"top 10%",
      end:"bottom 80%",
      onEnter() {
        body.classList.remove('dark-bg');
      },
      onEnterBack() {
        body.classList.add('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.home-gallery-slider',
      start:"top 10%",
      end:"top 70%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.remove('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.customer-reviews-section',
      start:"top 10%",
      end:"bottom 70%",
      onEnter() {
        body.classList.add('dark-bg');
      },
      onEnterBack() {
        body.classList.add('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.text-info-with-image.has-image',
      start:"top 50%",
      end:"bottom 0%",
      onEnter() {
        body.classList.remove('dark-bg');
      }
    }
  });
  gsap.from(body, {
    scrollTrigger: {
      trigger: '.full-width-video-section',
      start:"top 10%",
      end:"10% bottom",
      onEnter() {
        body.classList.add('video-zoom');
      },
      onEnterBack() {
        body.classList.remove('video-zoom');
      }
    }
  });
});
mm.add("(min-width: 992px)", () => {
  gsap.to (".about-text-wrapper", {
    scrollTrigger: {
      trigger: '.about-text-wrapper',
      start:"top top",
      end:"bottom 50%",
      pin: '.about-text-wrapper .left-box',
    }
  });
  gsap.to (".our-values-section", {
    scrollTrigger: {
      trigger: '.our-values-section',
      start:"top top",
      end:"bottom 50%",
      pin: '.our-values-section .left-box',
    }
  });
});